import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { FavoriteModalComponent } from 'src/app/_shared/component/favorite-modal/favorite-modal.component';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import { PropertyState } from 'src/app/workspace/state/property.state';

@Component({
  selector: 'app-favorite-widget',
  templateUrl: './favorite-widget.component.html',
  styleUrls: ['./favorite-widget.component.scss'],
})
export class FavoriteWidgetComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    public authorizeService: AuthorizeService,
    private propertyState: PropertyState,
    public userState: UserState,
    public appState: AppState,
  ) { }

  ngOnInit() { }

  openFavoriteModel() {
    if (this.authorizeService.canAct('favorites')) {
      this.dialog.open(FavoriteModalComponent, {
        data: {
          action: 'add',
          dataType: 'property',
          dataList: this.propertyState.listPropertySetValue,
        },
      });
    }
  }
}
